import isApiError from "@insite/client-framework/Common/isApiError";
import { ServiceResult, get } from "@insite/client-framework/Services/ApiService";

// export interface ViewMyStatementAPIParameter { }

export interface ViewMyStatementsModel {
    properties: {};
    statementDates: [];
    uri: null | string;
}

export interface StatementDetailsAPIParameter {
    statementNo: string;
}

export interface StatementDetailsModel {
    pdfString: string;
    properties: {};
    uri: null | string;
}

const url = "api/v1/statements";

export async function getAllStatements(
): Promise<ServiceResult<ViewMyStatementsModel>> {
    try {
        const resultModel = await get<ViewMyStatementsModel>(url);
        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getStatementDetail(
    parameter: StatementDetailsAPIParameter,
): Promise<ServiceResult<StatementDetailsModel>> {
    try {
        const resultModel = await get<StatementDetailsModel>(`${url}/${parameter.statementNo}`);
        return {
            result: resultModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}